// Какие картинки вообще имеют заранее нарезанные варианты.
//
// Правило одно на два места: по нему `image-loader.js` решает, переписывать ли
// URL на рунг лестницы, а компоненты — ставить ли `unoptimized`. Держать его в
// одном файле обязательно: если сторона-компонент и сторона-загрузчик разойдутся,
// next/image начнёт печатать srcset из четырёх ОДИНАКОВЫХ ссылок — браузер
// выберет по `sizes` ширину, которой на самом деле нет, и скачает полноразмерный
// файл, думая, что взял маленький. Ровно на это и ругается предупреждение
// «loader property that does not implement width».

/** Ширины, под которые генератор нарезает варианты (admin src/modules/r2-file/variants.ts). */
export const VARIANT_LADDER = [256, 512, 1024, 1600]

/**
 * Хост, на котором варианты действительно лежат (публичный CDN магазина).
 * Берётся из env, иначе — известный прод-хост.
 */
export function cdnHost() {
  const base = process.env.NEXT_PUBLIC_CDN_BASE_URL
  if (base) {
    try {
      return new URL(base).host
    } catch {
      /* fall through */
    }
  }
  return "cdn.owlcat.club"
}

/**
 * Есть ли у этого src нарезанные варианты.
 *
 * Нет — у чужих хостов (на деве это picsum.photos), у `data:`/`blob:`, у
 * пресайн-прокси портала, у уже нарезанного ключа и у форматов без растровых
 * вариантов (svg/gif и всё без расширения).
 */
export function hasPrebakedVariants(src) {
  if (!src || typeof src !== "string") return false
  if (src.startsWith("data:") || src.startsWith("blob:")) return false
  if (src.includes("/api/media/")) return false
  if (/__w\d+\.webp($|[?#])/i.test(src)) return false
  if (!src.includes(cdnHost())) return false
  return /\.(jpe?g|png|webp)($|[?#])/i.test(src)
}
